<template>
  <div class="aboutus">
    <div class="aboutus-title">
      <div>北京精讯云顿数据软件有限公司</div>
      <p>
        精以至诚，讯达天下。从1994年起，精讯公司专注中国价值信息服务，累计25年，将改革开放40年的数据用心收集、分类、标引、编辑整合，为国内外政府机构、公共图书馆和高校图书馆、500强企业服务，在大数据、人工智能领域取得成果，凭借自主研发的NASS、NDPP、SDPP三大数据管理应用平台，为用户服务。
        公司总部位于北京，在上海、石家庄、香港设于分支机构。
      </p>
    </div>
    <div class="aboutus-content">
      <p class="content-title">发展历程</p>
      <div class="content-img"></div>
      <div class="content-info">
        <div class="info-item">
          <p class="item-time">2019年6月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            公司受邀参加“中国世界文化遗产监测2019年年会”，与来自全国25个省（直辖市、自治区）及澳门特别行政区的文物管理机构代表、遗产地代表、世界文化遗产相关机构代表及专家交流分享世界文化遗产保护监测的先进经验。
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2019年5月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            公司受邀参加“数字资源规范化/标准化建设研讨会暨Calis第十七届引进数据库培训周”，对新形势下如何做好图书馆资源建设、加强科学管理、助力“双一流”学科发展、创新服务内容等问题进行了深入的探讨及交流
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2014-2018年</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            深耕公司自研技术，先后推出了，手机移动端舆情服务、INFOTAG标签管理系统、SOSHOO数据搜数系统，并在NASS系统的帮助下，成功研发台研网和京津冀一体化平台。把大数据运用到了实处。包含新闻，微博，微信等等。平台数据量均达到百万以上
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2014年3月</p>
          <div class="item-dots"></div>
          <div class="item-ind">续签Calis，并在5月举行的DRAA年会上以单篇下载成本最低的身份排在各家数据库之前</div>
        </div>
        <div class="info-item">
          <p class="item-time">2013年5月</p>
          <div class="item-dots"></div>
          <div class="item-ind">总裁王稼夫于天津师范大学Calis第十一届年会发表演讲《大数据时代的服务思考》</div>
        </div>
        <div class="info-item">
          <p class="item-time">2013年</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            加入微信监测服务，进一步开发和维护NDPP系统和舆情管理平台，开始与众多业界翘楚合作，为客户提供全方位舆情解决方案
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2011年</p>
          <div class="item-dots"></div>
          <div class="item-ind">产品线达10条以上，服务类型激增至50余种</div>
        </div>
        <div class="info-item">
          <p class="item-time">2009~2010年</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            自主研发舆情分析系统，实现了大数据环境下信息源的自动爬取、清洗和分类、编辑技术的全新突破应用。
            自主研发NDPP和SDPP信息管理平台，整合公司数据资源，提升数据应用和管理的能力
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2008年5月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            与北京奥组委，国家体育总局和北京市政府共同打造奥运24小时信息监测与舆情分析专题，保障了奥运期间政府掌控信息的全面性与解决问题的及时性
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2007年11月</p>
          <div class="item-dots"></div>
          <div class="item-ind">搜数网携手百度推出专业统计数据搜索频道</div>
        </div>
        <div class="info-item">
          <p class="item-time">2006年8月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            推出大陆首个专业统计数据检索网站——搜数网，为政府与企业决策提供数字化应用以及计算的新服务
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2004年</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            与清华大学共同研发OCR中文扫描识别系统，在技术中取得了突破，再次提升了公司数据生产质量
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">2001年12月</p>
          <div class="item-dots"></div>
          <div class="item-ind">被信息产业部指定为“国家信息资源开发利用试点工程</div>
        </div>
        <div class="info-item">
          <p class="item-time">2000年10月</p>
          <div class="item-dots"></div>
          <div class="item-ind">开始向政府和500强企业提供个性化定制服务，在互联网寒冬中扶犁深耕。</div>
        </div>
        <div class="info-item">
          <p class="item-time">1991年1月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            开始与国内众多政府机构达成战略合作伙伴关系，同年成为《中华人民共和国经贸部文告》唯一海外中代理
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">1998年10月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            出版《中国要人》，成为公司大数据应用的第一个成果，是当时两岸四地政商学界和当年度重要经济数据的必备读物。
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">1997年10月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            陆续成为Financial Times、Reuters、新华社、国家信息中心等国内外著名通讯社以及传媒机构的数据供应商
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">1997年5月</p>
          <div class="item-dots"></div>
          <div class="item-ind">
            正式推出集10个数据库为一体的一站式中文全文检索数据库平台，得到政府，公共图书馆、大学的广泛好评
          </div>
        </div>
        <div class="info-item">
          <p class="item-time">1994年5月</p>
          <div class="item-dots"></div>
          <div class="item-ind">利用数据库和全文检索引擎，以传真形式点对点 向全球著名跨国公司提供中文信息服务。</div>
        </div>
      </div>
      <div class="content-jieshao">
        <p class="content-title">企业文化</p>
        <div class="content-img"></div>
        <p>一个追求信念、追求卓越的公司</p>
        <div>我们的共识</div>
        <p>对我们所经营的事业执着追求、衷心热爱</p>
        <p>对我们创作的产品规范严谨、质量卓越</p>
        <p>对我们的客户呵护备至、忠心耿耿！</p>
        <p>这种共识形成了我们的企业文化：尊重个人 讲求团队 有效领导 服务用户 团结业界 贡献股东 奉献国家</p>
        <div>我们的理念</div>
        <p>信息银行 信息共享 利益共享</p>
        <div>我们的信仰</div>
        <p>将资讯当作使命 不仅需要智慧 更需要勇气和坚定不移的信念！</p>
        <div>核心价值观</div>
        <p>优质资讯 优胜之道</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.aboutus-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_aboutus.png) center no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
  }
  p {
    width: 60%;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 28px;
  }
}
.aboutus-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 64px 0;
  cursor: pointer;
  .content-title {
    margin: 0 auto 16px;
    font-size: 32px;
    font-weight: 600;
    color: #333333;
  }

  .content-img {
    width: 0;
    height: 0;
    border: 28px solid;
    border-color: #ff6845 transparent transparent;
  }

  .content-info {
    position: relative;
    width: 60%;
    margin: 30px 0 60px 20%;

    &::before {
      z-index: -1;
      position: absolute;
      left: 194px;
      content: ' ';
      height: 100%;
      width: 4px;
      background-color: #e5e5e5;
    }

    .info-item {
      margin: 40px 0;

      .item-time {
        display: inline-block;
        width: 160px;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        text-align: right;
      }

      .item-dots {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 0 24px;
        border: 4px solid #ffffff;
        border-radius: 50%;
      }

      .item-ind {
        display: inline-block;
        width: 50%;
        height: 100%;
        margin: 0 auto;
        padding: 24px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.8;
        color: #333333;
        border-radius: 0px 10px 10px 10px;
      }
    }

    .info-item:nth-child(3n + 1) {
      .item-dots {
        background-color: #007aff;
      }

      .item-ind {
        background-color: #edf5fd;
      }
    }

    .info-item:nth-child(3n + 2) {
      .item-dots {
        background-color: #00baff;
      }

      .item-ind {
        background-color: #effbff;
      }
    }

    .info-item:nth-child(3n + 3) {
      .item-dots {
        background-color: #0014ff;
      }

      .item-ind {
        background-color: #f0f1ff;
      }
    }
  }
  .content-jieshao {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    div {
      margin: 48px 0;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
    .content-title {
      margin: 0 auto 16px;
      font-size: 32px;
      font-weight: 600;
      color: #333333;
    }
    .content-img {
      width: 0;
      height: 0;
      border: 28px solid;
      border-color: #ff6845 transparent transparent;
    }
  }
}
</style>
